import React from "react";
import rg4js from "raygun4js";
import error from "../../images/stod2_401_error.png";
import LinkButton from "../Shared/Link/Link";
import { Container, ErrorDescription, ErrorImage, ErrorHeader } from "./Styles";
import { SYN_REDIRECT } from "../../utility/constants";
import { Break } from "../Shared/Layout/Layout";

export default function Unauthorized() {
  rg4js("send", { error: "Landed on Unauthorized page" });
  window.analytics.page("Unauthorized");
  return (
    <Container>
      <ErrorHeader>Úps... hvað gæti hafa gerst?</ErrorHeader>
      <ErrorImage>
        <img src={error} alt="Ekki réttindi" />
      </ErrorImage>
      <ErrorDescription style={{ maxWidth: "665px" }}>
        Þú ert ekki með aðgang að þessari síðu. Ef þú lendir áfram í vandræðum
        getur þú haft samband við okkur í gegnum Netspjallið eða þjónustuver
        Vodafone í síma 1414.
      </ErrorDescription>
      <Break />
      <LinkButton to={SYN_REDIRECT} label="Fara á syn.is" />
    </Container>
  );
}
